module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h1', [_vm._v("Chapter 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1em",
      "line-height": "1.5",
      "text-indent": "-1.5em"
    }
  }, [_vm._v("The tape recorder stopped, its final click as startling as a gunshot. The first two times he’d played it, Downing hit the stop button as soon as the speakers fell into that eerie electronic hum. This last time, after five minutes of recorded death, he’d let it run two more minutes to the end to make sure there was nothing else.")])]), _vm._v(" "), _c('div', {
    staticClass: "body pb-body pb-chapter",
    attrs: {
      "id": "chapter-1"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He checked the hallway outside his office, making sure no one had heard the killer’s taunt—a crazy, irrational fear, he knew, because the door was shut and it was late. But he checked anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With a pencil, he turned the envelope over, postmark side up. That’s when he knew for sure, knew Corbett was playing his mind games again. Mailed from the post office three blocks from Downing’s house. Corbett was twisted, but very careful. The envelope and the cassette box would offer no other clues, Downing was sure, but he pulled an evidence bag from his jacket pocket and dropped them both in, then dropped the bag into his bottom drawer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It had been ten years. Why now? Downing pressed the rewind button again and watched the sliver of black ribbon spin back onto the left-hand spool. This time, he set the timer on his wristwatch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Play.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“. . . a Channel 7 exclusive, and we’ll play that tape for you now,” it began. “We should note that it is graphic and disturbing, so viewer discretion is advised.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A low hiss: the electronic crackle and hum of a 9-1-1 tape recorded from a television speaker. Then:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Greene County Fire. Is this an emergency?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, uh, it’s my mom.” Young kid, early teens, voice cracking. “She was just putting the groceries away and, oh God, she’s really having trouble breathing. I’m the only one home.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was a Wednesday, late afternoon, early November, the temperature dropping fast. Downing knew that much from other news reports and the week-old "), _c('em', [_vm._v("Waynesburg Courier")]), _vm._v(" clipping that was folded into the envelope with the cassette. He imagined the rest: A bored dispatcher, a woman, expecting another space-heater fire out there among western Pennsylvania’s shivering rural poor. She’d have swept the mouthpiece of her headset down to her lips and jabbed the pickup button on the Automated Location Identifier, and the caller’s phone number and address would have flashed onto her video screen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Downing checked the newspaper story. 29 Ruff Creek Lane, Waynesburg.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s your name?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“JoAnn Cuddy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s your mom’s name, right? What’s your name?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mark.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Downing closed his eyes. The dispatcher would have typed in the name and poked another console button, channeling that information through the county’s Computer-Aided Dispatch System. An electronic form would have blinked onto her screen, listing the nearest major cross streets to 29 Ruff Creek Lane and a code signifying which local ambulance company covers that area.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, Mark. Can your mom talk?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. No. I don’t think so. She’s really—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How old’s your mom?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thirty-eight. No, thirty-nine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is she conscious?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, but, oh God. Can you send somebody really quick?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She should have typed “conscious” into the form and transmitted it to—Downing opened his eyes and checked the newspaper story—Weaver Ambulance and Rescue in Waynesburg.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’re on their way. So your mom’s still breathing then?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Trying.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Something glass shattered in the background, followed by the crunch of splitting wood and the heavy, sickening thump of flesh on floor. The phone banged again and again, hollow and sharp, like it was hitting a wall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sir? Are you there? Sir?” Downing checked his watch. The digital timer raced through ten, fifteen, twenty seconds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She fell, then she threw up.” Kid’s voice panicky now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is she still conscious?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t think so.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What did she throw up?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just some yogurt. She was eating it a couple minutes ago when she started, like, choking.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The dispatcher probably went for her allergic reactions key-question cards. The prearrival instructions are printed on the back of them. Downing winced at the thought. So logical, but so useless.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If she’s unconscious and still vomiting, I want you to turn her onto her side and make sure her airway is clear so she doesn’t choke. Can you do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just a minute.” Panicked whimpers as the kid worked. Downing checked his watch again. Sounds of desperation filled his head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay. She’s on her side, but she’s hardly breathing. Oh God. Jesus! How long until they get here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Stay with me now. Your mom have allergies? She wearing any sort of medical-alert bracelet?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is really bad. No. No. She wasn’t allergic to anything, I don’t think.” Kid sobbing now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How’s her skin feel? Is it pale, cool, moist?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hang on.” Downing flinched at the dropped handset’s hollow report “Skin’s cold, and really, really white.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, listen. She’s going into shock. I want you to put her feet and legs up on something. If she’s on the floor, grab a kitchen chair and put her legs up on it. Got that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Silence, then the rhythmic cadence of convulsion, as unmistakable as the sound of lovers. Downing put his head down on the desk. "), _c('em', [_vm._v("So goddamned useless.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sir? Are you there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s having a seizure or something. She’s—where the fuck are they?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Listen. This is important. Your mom is having convulsions. You need to move everything away from her, anything she could hurt herself on.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pots, pans, kitchen utensils, furniture. Make sure it’s all out of her reach. If she’s wearing a collar, loosen it if you can. And don’t try to restrain her. She’ll be all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now. And don’t put anything in her mouth, especially your fingers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Downing’s head filled with more sounds—chairs tipping, a table being shoved aside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh God, she’s dying!” Kid screaming now. “What’s wrong with her?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Stay calm. She needs you. Is your mom pregnant?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. No. What else should I be doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Downing could almost see her struggle. The body overwhelmed, the eyes uncomprehending, reaching, clutching, dying.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She stopped shaking, but I don’t think she’s breathing. Not breathing at all. Mom. Mom! What should I do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Downing could hear the dispatcher fumbling through her key-question cards. One choice left: CPR. But there was a commotion as she started her instructions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In here!” the caller shouted to the arriving paramedics, and the line went dead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Downing poked a button on his wristwatch. The timer stopped with a tinny beep. Did anyone hear? He checked the hallway again, then peeked around the corner into the squad room. Silverwood looked up from his typewriter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jesus, Grady. You look like hell.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Downing nodded, forced a smile. “Long day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Go home.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Downing went back to his desk, sweating, dizzy, wiping his hands on the leg of his pants. "), _c('em', [_vm._v("Why now?")]), _vm._v(" A deep breath. Then another.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He pulled a clean notepad from a drawer and wrote a large number 7 at the top, then circled it. He wrote the name JoAnn Cuddy on the top line and underlined it twice. Beside it, he added the date of her death as described in the "), _c('em', [_vm._v("Courier")]), _vm._v(" clipping, realizing what it meant as soon as he lifted the pen and looked at the numbers: God damn. Ten years to the day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Vt. consumed yogurt approx. 7 mins. prior to resp. arrest,” he scribbled, his hand suddenly gone weak. “Rec. excerpted 911 tape by mail. (Anon.) Recorded from TV-7.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He wiped his hands again so they wouldn’t smear the ink then checked his watch. The numbers were frozen where he stopped them, and he copied them onto the notepad. Five minutes, nineteen seconds. So fast. So damned fast. They all were.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b08b6d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/chapter-001-chapter-1.vue
// module id = 66
// module chunks = 0